import { useState } from 'react'
import { useBoolean } from 'usehooks-ts'

import CfSectionShell, { CfSectionShellFields } from '../cf-section-shell'
import { Stack } from '~/components-v2'
import { LiteYouTubeEmbed } from './YTEmbed'
import { WistiaPlayer } from '@wistia/wistia-player-react'
import { VideoFigure } from '~/components-v2/figure/video-figure'
import { CfMedia } from '../cf-media'
import type { CfImage } from '~/types/contentful'

export interface FeatureRowFields {
  headline?: string
  subHeadline?: string
  image?: CfImage
  mobileImage?: CfImage
  videoId?: string
  videoType?: 'Youtube' | 'Vimeo' | 'Wistia'
}

interface CfFeatureRowSectionProps {
  fields: CfSectionShellFields & FeatureRowFields
}

export function CfFeatureRowSection({ fields }: CfFeatureRowSectionProps) {
  const { id, paddingTop, paddingBottom, showBottomBorder, theme } = fields
  const { headline, subHeadline, image, mobileImage, videoId, videoType } =
    fields
  const imageUrl = image?.fields?.file?.url
  const mobileImageUrl = mobileImage?.fields?.file?.url

  //removed setPlayTime lint error
  const [playtime] = useState(0)
  const { value, setTrue } = useBoolean()
  // const moveVideoTime = (time: number) => {
  //   setPlaytime(time)
  //   setTrue()
  // }

  return (
    <CfSectionShell
      id={id}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      showBottomBorder={showBottomBorder}
      theme={theme}
    >
      <div className="cf-feature-row">
        {headline && (
          <Stack className="centered-section-title" as="hgroup">
            <h2>{headline}</h2>
            {subHeadline && <p>{subHeadline}</p>}
          </Stack>
        )}

        {imageUrl && (
          <figure className={'featured-image'}>
            <CfMedia
              className={mobileImage ? 'desktop' : undefined}
              media={image}
            />
            {mobileImageUrl && (
              <CfMedia
                className="mobile"
                media={mobileImage}
                imageWidth={800}
              />
            )}
          </figure>
        )}

        {videoType && videoId !== undefined ? (
          <article className="featured-video">
            {videoType === 'Youtube' && (
              <LiteYouTubeEmbed
                isEnabled={value}
                enable={setTrue}
                id={videoId}
                title="Omni Analytics - Introduction video"
                playtime={playtime}
              />
            )}

            {videoType === 'Wistia' && <WistiaPlayer mediaId={videoId} />}

            {videoType === 'Vimeo' && (
              <VideoFigure
                src={`https://player.vimeo.com/video/${videoId}`}
                title={headline ? headline : ''}
              />
            )}

            {/* {showJumpLinks && (
              <aside>
                <ul>
                  <li onClick={() => moveVideoTime(94)}>
                    <h5>(1:34)</h5>
                    <h3>Analyze with your preferred language</h3>
                    <p>
                      Use the point & click UI, SQL, Excel, or AI to get answers
                      from your data.
                    </p>
                  </li>
                  <li onClick={() => moveVideoTime(327)}>
                    <h5>(5:27)</h5>
                    <h3>Promote to the shared model</h3>
                    <p>
                      Explore freely in your workbook, then build upon your team's
                      shared data model.
                    </p>
                  </li>
                  <li onClick={() => moveVideoTime(390)}>
                    <h5>(6:30)</h5>
                    <h3>Move faster with dbt</h3>
                    <p>
                      With Omni's dbt integration, you can pull in metadata, create
                      new models, and more.
                    </p>
                  </li>
                </ul>
              </aside>
            )} */}
          </article>
        ) : null}
      </div>
    </CfSectionShell>
  )
}
